import FormControlLabel from '@mui/material/FormControlLabel';
import Grid from '@mui/material/Grid';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Typography from '@mui/material/Typography';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

const Language = () => {
  const { t, i18n } = useTranslation();
  const [value, setValue] = useState(
    i18n.language?.includes('en') ? 'en' : 'vi'
  );

  const handleChange = useCallback(
    (event) => {
      setValue(event.target.value);
      i18n.changeLanguage(event.target.value);
    },
    [i18n]
  );

  return (
    <section className="shoping-cart spad">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography variant="h4" gutterBottom>
                  {t('language.head1')}
                </Typography>
                <Typography variant="body1" gutterBottom>
                  {t('language.body1')}
                </Typography>
                <RadioGroup
                  aria-labelledby="demo-controlled-radio-buttons-group"
                  name="controlled-radio-buttons-group"
                  value={value}
                  onChange={handleChange}
                >
                  <FormControlLabel
                    value={'vi'}
                    control={<Radio />}
                    label="Tiếng Việt"
                  />
                  <FormControlLabel
                    value={'en'}
                    control={<Radio />}
                    label="English"
                  />
                </RadioGroup>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="h6" gutterBottom>
                  {t('language.head2')}
                </Typography>
                <Typography variant="body1" gutterBottom>
                  {t('language.body2')}
                </Typography>
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Language;
